/**
 * Validate all fields in the container.
 *
 * - Fields with required attribute are all required.
 * - email field name should be "email".
 * - email confirm field name should be "email_confirm".
 */

export const isFormValid = ($container, validateList = true) => {
	const ERROR_REQUIRED_CLASS = "invalid-required";
	const ERROR_INVALID_EMAIL_CLASS = "invalid-email";
	const ERROR_INVALID_CONFIRM_CLASS = "invalid-confirm";

	const isFieldValid = (field, $container) => {
		let isValid = true;

		field.classList.remove(ERROR_REQUIRED_CLASS);
		field.classList.remove(ERROR_INVALID_EMAIL_CLASS);
		field.classList.remove(ERROR_INVALID_CONFIRM_CLASS);

		// Required validation.
		if (field.hasAttribute("required")) {
			if (field.value.trim()) {
				field.classList.remove(ERROR_REQUIRED_CLASS);
			} else {
				field.classList.add(ERROR_REQUIRED_CLASS);
				isValid = false;
			}
		}

		// Email validation.
		if ("email" === field.type && isValid) {
			if (
				!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9-.]{2,61}$/.test(
					field.value
				)
			) {
				field.classList.add(ERROR_INVALID_EMAIL_CLASS);
				isValid = false;
			} else {
				field.classList.remove(ERROR_INVALID_EMAIL_CLASS);
			}
		}

		// Email Confirm Validation.
		if (field.name.includes("email_confirm")) {
			// Check if the field is in a modal.
			const $email = $container.find('[name="email"]');
			if (
				!$email.hasClass(ERROR_REQUIRED_CLASS) &&
				!$email.hasClass(ERROR_INVALID_EMAIL_CLASS)
			) {
				if ($email.val() !== field.value) {
					field.classList.add(ERROR_INVALID_CONFIRM_CLASS);
					isValid = false;
				} else {
					field.classList.remove(ERROR_INVALID_CONFIRM_CLASS);
				}
			}
		}

		return isValid;
	};

	let isValid = true;
	$container.find("[name]").each((index, field) => {
		if (!isFieldValid(field, $container)) {
			isValid = false;
		}
	});

	// Validate opt-in list.
	if (validateList) {
		const selector =
			"[name='newsletter_name[]'][type=hidden], [name='newsletter_name[]'][type=checkbox]:checked";

		const list = $container
			.find(selector)
			.map((index, field) => field.value)
			.get();

		if (!list.length) {
			$container.find(".error-invalid-list").show();
			isValid = false;
		} else {
			$container.find(".error-invalid-list").hide();
		}
	}

	return isValid;
};

export const replaceWithSuccess = ($form, mode = "signup", email) => {
	let message = "";

	switch (mode) {
		case "update":
			message = "Thank you! Your email preferences were updated successfully.";
			break;
		case "unsubscribe":
			message = "You have successfully unsubscribed <a class='email'>" + email + "</a> from Trending News.";
			var $title = document.querySelector(".title-sorry");
			if ($title) {
				$title.style.display = "none";
			}
			break;
		default:
			var $title = document.querySelector(".title");
			if ($title) {
				$title.style.display = "none";
			}
			var $subTitle = document.querySelector(".subtitle");
			if ($subTitle) {
				$subTitle.style.display = "none";
			}
			message =
				"<h3 class='success'>Thank you!</h3> <br>You have successfully subscribed to Trending News";
	}
	var $title = document.querySelector('.wp-block-ess-newsletter-signup__headline');
	if ($title) {
		$title.style.display = "none";
		$form.replaceWith(`<div class="subscribe-form-success-black">${message}</div>`);
	} else {
		var $inline = document.querySelector('#subscribe-step1');
		if ($inline) {
			$form.replaceWith(`<div class="subscribe-form-success-white">${message}</div>`);
		} else {
			$form.replaceWith(`<div class="subscribe-form-success">${message}</div>`);
		}
	}

	var $topBar = document.querySelector('.top_image');
	if ($topBar) {
		$topBar.style.display = "none";
	}
	var $content = document.querySelector('.email-preferences-content');
	if ($content) {
		$content.setAttribute('style', 'border-radius: 16px;')
	}
};

export const showErrorMessage = ($response) =>
	$response.text("Oops! Something went wrong. Please try again later.").show();

export const doSubscribeAjax = (
	$form,
	successCallback,
	failCallback,
	alwaysCallback
) => {
	const $button = $form.find("[type=submit]");
	const $response = $form.find(".subscribe-form-response");
	const $loading = $form.find(".subscribe-form-loading");

	$button.attr("disabled", "");
	$response.hide();
	$loading.show();

	const data = $form.serialize() + "&action=newsletter_subscribe";
	const mail = $form.find('input[type="email"]').val();

	$.ajax({
		url: pubstack.ajaxUrl,
		method: "POST",
		dataType: "JSON",
		data,
	})
		.done(function (response) {
			trackCordialNewsletter($form);
			// check if this subscription process has multiple steps (e.g. Article inline NL form)
			if ("subscribe-next-step" !== $form.data("mode")) {
				const email = mail ? mail : '';
				if ($form.data("redirect")) {
					location.href = $form.data("redirect");
				} else {
					replaceWithSuccess($form, $form.data("mode"), email);
				}
			}
			successCallback && successCallback();
		})
		.fail(function (xhr, textStatus, error) {
			// Will need to reproduce this error in order to get the proper json tree structure
			if (
				xhr.responseJSON &&
				xhr.responseJSON.code === "CONTACTS_DUPLICATE_KEY"
			) {
				console.log("CONTACTS_DUPLICATE_KEY");
				showErrorMessage("Please try again soon.");
			} else {
				showErrorMessage($response);
				failCallback && failCallback();
			}
		})
		.always(function () {
			$loading.hide();
			$button.removeAttr("disabled");
			alwaysCallback && alwaysCallback();
		});
};

const trackCordialNewsletter = ($form) => {
	if (typeof crdl === "undefined") {
		return;
	}

	let event,
		properties = {};

	const email = $form.find("[name=email]").val();

	if ("update" === $form.data("mode")) {
		event = "preference_update";
	} else if ("unsubscribe" === $form.data("mode")) {
		event = "unsubscribe";
	} else {
		event = "newsletter_signup";
		properties["source"] = $form.find("[name=source]").val();
	}

	var auth_data = {
		email: email
	};
	var firstName = $form.find("[name=first_name]").val();
	var lastName = $form.find("[name=last_name]").val();
	var contact_data = {
		'channels': {
			'email': {
				'subscribeStatus': 'subscribed'
			}
		},
		'first_name': firstName,
		'last_name': lastName,
		'girlsunited-trending-news-subscribers': true
	};
	crdl('contact', auth_data, contact_data);
	crdl("event", event, properties);
};
